import React, { useMemo } from 'react'
import { CalendarSelection, Day } from '../../../../types/calendar.types'

type DailyCalendarProps = {
  selection: CalendarSelection
  onSelectionChange: (selection: CalendarSelection) => void
  availableDailyDays: Day[]
}

export const DailyCalendar: React.FC<DailyCalendarProps> = ({
  selection,
  onSelectionChange,
  availableDailyDays = []
}) => {
  // Generate default daily intervals if none provided
  const generateDailyIntervals = () => {
    return Array.from({ length: 7 }, (_, i) => ({
      day: i + 1,
      isEnabled: availableDailyDays.some((day) => day.day === i + 1),
      isSelected: i + 1 === selection.value
    }))
  }

  const calendarDays = useMemo(() => generateDailyIntervals(), [selection, availableDailyDays])

  const handleDaySelect = (day: number) => {
    onSelectionChange({
      ...selection,
      value: day
    })
  }

  return (
    <div className=''>
      {/* Calendar Grid */}
      <div className='flex flex-wrap gap-3 w-full'>
        {calendarDays.map(({ day, isEnabled, isSelected }) => {
          const getButtonClasses = () => {
            const baseClasses =
              'flex-1 h-14 rounded-lg flex items-center justify-center text-[14px] font-[500] transition-all duration-200 border min-w-[120px]'

            if (isSelected) {
              return `${baseClasses} bg-[#232323] text-white border-[#232323]`
            }

            if (isEnabled) {
              return `${baseClasses} bg-white text-[#232323] border-[#E5E7EB] hover:border-[#232323] hover:scale-105`
            }

            return `${baseClasses} bg-[#F3F4F6] text-[#9CA3AF] cursor-not-allowed border-[#E5E7EB]`
          }

          return (
            <button key={day} onClick={() => handleDaySelect(day)} disabled={!isEnabled} className={getButtonClasses()}>
              {day}
            </button>
          )
        })}
      </div>
    </div>
  )
}
